<p-table [value]="fundcodesHistory"
         dataKey="fundCodeId"
         styleClass="rc-datatable-funds"
         [scrollable]="true"
         scrollHeight="400px"
         [expandedRowKeys]="expandedRows"
         (onRowExpand)="onRowExpand($event)"
         (onRowCollapse)="onRowCollapse($event)">

  <ng-template pTemplate="caption">
    <div class="flex flex-wrap justify-content-end gap-2">
      <p-button label="Expand All" severity="secondary" icon="pi pi-plus" text (onClick)="expandAll()" />
      <p-button label="Collapse All" severity="secondary" icon="pi pi-minus" text (onClick)="collapseAll()" />
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th style="width: 1rem"></th>
      <th>Campaign</th>
      <th>Cycle</th>
      <th>Total</th>
      <th>Remaining</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-fundcodeHistoryItem let-expanded="expanded">
    <tr>
      <td>
        <!-- expand button should only be visible if there is rowexpansion data available -->
        <p-button type="button" pRipple [pRowToggler]="fundcodeHistoryItem" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
      </td>
      <td>{{ fundcodeHistoryItem.campaignName }}</td>
      <td>{{ fundcodeHistoryItem.fundcode }}</td>
      <td>{{ fundcodeHistoryItem.amount | currency: 'USD' }}</td>
      <td>
        <span [ngStyle]="fundcodeHistoryItem.remaining < 0 ? { 'color': 'red' } : {}">{{ fundcodeHistoryItem.remainingAmount | currency: 'USD' }}</span>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-fundcodeHistoryItem>
    <ng-container *ngIf="childRowData[fundcodeHistoryItem.fundCodeId]?.length; else noChildData">
      <tr *ngFor="let child of childRowData[fundcodeHistoryItem.fundCodeId]" class="rc-datatable-internal">
        <td class="px-2"></td>
        <td colspan="2" class="text-left">
          <b>{{ child.name }}</b>
          <i class="inline-block ml-2">- {{ child.relationship }}</i>
        </td>
        <td>{{ child.amount | currency: 'USD' }}</td>
        <td>
          <span [ngStyle]="child.remainingAmount < 0 ? { 'color': 'red' } : {}">
            {{ child.remainingAmount | currency: 'USD' }}
          </span>
        </td>
      </tr>
    </ng-container>
    <ng-template #noChildData>
      <tr>
        <td colspan="5" class="text-center">No additional data available</td>
      </tr>
    </ng-template>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5" class="text-center">No data available</td>
    </tr>
  </ng-template>
</p-table>

<div class="imported-dialog-footer" *ngIf="displayOneModalPopup">
  <p-button label="Close"  (click)="onClose()"></p-button>
</div>
